import React, { useContext } from 'react'
import { Fab as MuiFab, makeStyles } from '@material-ui/core'
import { useTheme } from '@material-ui/core/styles'
import { WHITE } from '../../theme'
import { ClassValue } from 'classnames/types'
import classNames from 'classnames'
import { ResponsiveContext } from '../../utils/context/responsiveContext'
import { Theme } from '@material-ui/core/styles/createMuiTheme'

const useStyles = makeStyles<Theme, { isLargeScreen: boolean }>(
	(theme) => (
		{
			fabHover: {
				fabHover: {
					'&:hover': {
						backgroundColor: `${WHITE} !important`
					}
				}
			}
		}
	)
)

interface AcceptingProps {
	ariaLabel: string,
	onClick: () => void,
	isSelected: boolean,
	label: string | JSX.Element
	fabStyle?: string
	disabled?: boolean
}

type FabProps = AcceptingProps

const Fab: React.FC<FabProps> = (
	{
		ariaLabel,
		onClick,
		isSelected,
		label,
		fabStyle,
		disabled
	}
) => {
	const theme = useTheme()
	const { isLargeScreen } = useContext(ResponsiveContext)
	const classes = useStyles({ isLargeScreen })

	const fabHoverClass: ClassValue = classNames(
		{
			[classes.fabHover]: !isSelected
		},
		fabStyle
	)

	return (
		<MuiFab
			disabled={disabled}
			variant="extended"
			color="primary"
			aria-label={ariaLabel}
			onClick={onClick}
			className={fabHoverClass}
			style={
				isSelected ?
					{
						borderRadius: 0,
						color: WHITE,
						background: theme.palette.blue.main
					}
					:
					{
						borderRadius: 0,
						color: theme.palette.blue.main,
						background: theme.palette.blue['5'],
						border: `1px solid ${theme.palette.blue.main}`
					}
			}
		>
			{label}
		</MuiFab>
	)
}

export default Fab
